var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import TroubleShooting from "one-trouble-shooting";
import KeyQuestion from "one-key-question";
import { toJS } from "mobx";
import { StepQuestionBusiness, } from "@business/newCreateRequest/stepsItems/questions";
import { observer } from "mobx-react-lite";
import { createForm } from "rc-form";
import { Button, Loader } from "oned";
import { combine } from "fe-toolkit";
import { ProgressBusiness, } from "@business/newCreateRequest/common/progress";
import { CommonBusiness, } from "@business/newCreateRequest/common/common";
import { AmplitudeEventName, PredefinedWoType, ProblemLevel, MobileDefinedClientType, StepType, QuestionReferenceType } from "@common/enums/base";
import { getCurrentEnv, isIH, sendAmplitude_Default } from "@common/utils";
import Cookies from "js-cookie";
import ResidentResponsibility from "../problem/residentResponsibility";
import { Modal, useTheme } from '@one/haven-design';
import { AlertFill } from "@one/haven-design-icons";
var StepsQuestions = inject(combine(StepQuestionBusiness, ProgressBusiness, CommonBusiness))(observer(function (props) {
    var initData = props.initData, keyQuestionsData = props.keyQuestionsData, setParam = props.setParam, keyQuestionAnswers = props.keyQuestionAnswers, form = props.form, troubleShootingData = props.troubleShootingData, troubleShootingAnswers = props.troubleShootingAnswers, next = props.next, loading = props.loading, currentUser = props.currentUser, clearAvailabilityData = props.clearAvailabilityData, woTypeId = props.woTypeId, residentResponsibilityVisible = props.residentResponsibilityVisible, setResidentResponsibilityVisible = props.setResidentResponsibilityVisible, getQuestionServiceAnswerConfigs = props.getQuestionServiceAnswerConfigs, questionServiceConfig = props.questionServiceConfig, setLevel = props.setLevel, toJump = props.toJump, onChangeServiceComboData = props.onChangeServiceComboData, setServiceComboByQuestionData = props.setServiceComboByQuestionData;
    var _a = useState(false), isIh = _a[0], setIsIh = _a[1];
    var _b = useState(false), serviceComboChangeVisible = _b[0], setServiceComboChangeVisible = _b[1];
    var _c = useState(null), serviceComboName = _c[0], setServiceComboName = _c[1];
    var _d = useState(null), serviceComboData = _d[0], setServiceComboData = _d[1];
    var theme = useTheme();
    useEffect(function () {
        initData();
        setIsIh(isIH());
        getQuestionServiceAnswerConfigs({ clientId: props.clientId, refType: QuestionReferenceType.ServiceCodeQuestion, triggerType: 0 });
    }, []);
    var residentResponsibilityCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, form.validateFields()];
                case 1:
                    _a.sent();
                    if (Cookies.get("residentResponsibilityCount") !== 'true' &&
                        woTypeId === PredefinedWoType.ResidentResponsibility) {
                        setResidentResponsibilityVisible(true);
                        return [2 /*return*/];
                    }
                    questionNext();
                    return [2 /*return*/];
            }
        });
    }); };
    var questionNext = function () {
        var initNewAvailabilityData = props.initNewAvailabilityData;
        sendAmplitude_Default(AmplitudeEventName.NewRSP_Step3to4, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            clientId: props.clientId,
            env: getCurrentEnv(),
        });
        clearAvailabilityData();
        initNewAvailabilityData();
        next();
    };
    var onChangeServiceCombo = function (questionId, answer, answerId, answerIds) {
        var matchedQuestionConfigs = questionServiceConfig.filter(function (item) { return item.questionId === questionId; });
        var selectTroulbleShootConfig = matchedQuestionConfigs && matchedQuestionConfigs.filter(function (item) { return item.questionOptionId === answerId; })[0];
        if (selectTroulbleShootConfig) {
            setServiceComboName(getComboName(selectTroulbleShootConfig) || '');
            setServiceComboChangeVisible(true);
            setServiceComboData(selectTroulbleShootConfig);
        }
        else {
            setServiceComboName('');
            setServiceComboData(null);
        }
    };
    var getComboName = function (config) {
        var categoryName = (config === null || config === void 0 ? void 0 : config.serviceCategoryAlias) ? config.serviceCategoryAlias : config.serviceCategoryName;
        var typeName = (config === null || config === void 0 ? void 0 : config.serviceCategoryAlias) ? config.serviceTypeAlias : config.serviceTypeName;
        var codeName = (config === null || config === void 0 ? void 0 : config.serviceCategoryAlias) ? config.serviceCodeAlias : config.serviceCodeName;
        var formatTypeName = typeName ? " > " + typeName : '';
        var formatCodeName = codeName ? " > " + codeName : '';
        return "" + categoryName + formatTypeName + formatCodeName;
    };
    var onChangeServiceComboSubmit = function () {
        setServiceComboByQuestionData(true);
        setServiceComboChangeVisible(false);
        var params = {
            clientId: Cookies.get("clientId"),
            clientType: isIH() ? MobileDefinedClientType.IHResidential : MobileDefinedClientType.NonIHResidential,
            parentId: (serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.id) ? serviceComboData.id : null
        };
        if (serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCategoryAliasId) {
            setLevel((serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCodeAliasId) ? ProblemLevel.LevelThree : ProblemLevel.LevelTwo);
        }
        else {
            setLevel((serviceComboData === null || serviceComboData === void 0 ? void 0 : serviceComboData.serviceCodeId) ? ProblemLevel.LevelThree : ProblemLevel.LevelTwo);
        }
        sendAmplitude_Default(AmplitudeEventName.Troubleshoot_Recommended_SVC_Go, {});
        onChangeServiceComboData(serviceComboData, params);
        toJump(StepType.Problem);
    };
    return loading ? (React.createElement(Loader, { visible: loading })) : (React.createElement(React.Fragment, null,
        residentResponsibilityVisible && React.createElement(ResidentResponsibility, { questionNext: questionNext }),
        !residentResponsibilityVisible && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dsm-card p-4 p-0-sm" },
                React.createElement("div", { className: "dsm-card-body" },
                    React.createElement("div", { className: "rsp-keyQuestion-reset" }, keyQuestionsData.length > 0 && (React.createElement(React.Fragment, null,
                        !isIh && React.createElement("h1", { className: "rsp-question-title" }, "Key Question"),
                        React.createElement(KeyQuestion, { form: form, callBack: function (answer) {
                                setParam("keyQuestionAnswers", JSON.stringify(toJS(answer)));
                            }, maxLength: 100, initAnswersData: keyQuestionAnswers
                                ? JSON.parse(toJS(keyQuestionAnswers))
                                : [], initQuestionsData: toJS(keyQuestionsData) })))),
                    React.createElement("div", { className: "rsp-keyQuestion-reset" }, troubleShootingData.length > 0 && (React.createElement(React.Fragment, null,
                        !isIh && React.createElement("h1", { className: "rsp-question-title" }, "Troubleshooting"),
                        React.createElement(TroubleShooting, { form: form, onChangeQuestions: onChangeServiceCombo, callBack: function (tAnswer) {
                                setParam("troubleShootingAnswers", JSON.stringify(toJS(tAnswer)));
                            }, maxLength: 100, initAnswersData: troubleShootingAnswers
                                ? JSON.parse(toJS(troubleShootingAnswers))
                                : [], initQuestionsData: toJS(troubleShootingData) })))))),
            React.createElement(Button, { type: "primary", className: "w-100 my-4 dsm-btn-primary dsm-btn", tag: "requestQuestionsBtn", onClick: residentResponsibilityCheck }, "Next")),
        React.createElement(Modal, { title: React.createElement(React.Fragment, null,
                React.createElement(AlertFill, { style: { color: theme.colorWarning3Default, fontSize: '20px', marginRight: '8px' } }),
                " Maintenance Request Change"), cancelText: "No, do not change", okText: "Yes, update combination", closable: false, okButtonProps: { className: isIH() ? "how-to-video-ok-ih" : "how-to-video-ok-normal" }, open: serviceComboChangeVisible, tag: "HowToVideo", width: 640, onCancel: function () {
                sendAmplitude_Default(AmplitudeEventName.Troubleshoot_Recommended_SVC_Close, {});
                setServiceComboChangeVisible(false);
                setServiceComboByQuestionData(false);
            }, onOk: onChangeServiceComboSubmit },
            "Based on your response to the troubleshooting question we have changed your maintenance request to be ",
            serviceComboName)));
}));
export default createForm()(StepsQuestions);
